(function () {
  function setActiveDot(section, activeIndex) {
    var dots = section.querySelectorAll('[data-ugc-gallery-target]');

    dots.forEach(function (dot, index) {
      var isActive = index === activeIndex;
      dot.classList.toggle('is-active', isActive);

      if (isActive) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  function getClosestItemIndex(viewport, items) {
    var viewportCenter = viewport.scrollLeft + viewport.clientWidth / 2;
    var closestIndex = 0;
    var closestDistance = Infinity;

    items.forEach(function (item, index) {
      var itemCenter = item.offsetLeft + item.offsetWidth / 2;
      var distance = Math.abs(viewportCenter - itemCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function initUgcGallery(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('.sd-ugc-gallery');

    sections.forEach(function (section) {
      if (section.dataset.sdUgcGallery === 'true') {
        return;
      }

      section.dataset.sdUgcGallery = 'true';

      var viewport = section.querySelector('.sd-ugc-gallery__viewport');
      var items = Array.prototype.slice.call(section.querySelectorAll('.sd-ugc-gallery__item'));
      var modal = section.querySelector('[data-ugc-gallery-modal]');
      var modalPanel = section.querySelector('.sd-ugc-gallery__modal-panel');
      var modalPlayer = section.querySelector('[data-ugc-gallery-player]');

      if (!viewport || !items.length) {
        return;
      }

      var scrollFrame = null;
      var isDragging = false;
      var startX = 0;
      var startY = 0;
      var startScrollLeft = 0;
      var hasDragged = false;
      var dragDirection = null;

      function startDrag(clientX, clientY) {
        isDragging = true;
        hasDragged = false;
        dragDirection = null;
        startX = clientX;
        startY = clientY;
        startScrollLeft = viewport.scrollLeft;
      }

      function moveDrag(clientX, clientY) {
        var deltaX = clientX - startX;
        var deltaY = clientY - startY;

        if (!dragDirection && (Math.abs(deltaX) > 6 || Math.abs(deltaY) > 6)) {
          dragDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'horizontal' : 'vertical';

          if (dragDirection === 'horizontal') {
            viewport.classList.add('is-dragging');
          }
        }

        if (dragDirection !== 'horizontal') {
          return;
        }

        if (Math.abs(deltaX) > 3) {
          hasDragged = true;
        }

        viewport.scrollLeft = startScrollLeft - deltaX;
      }

      function stopDrag() {
        if (!isDragging) {
          return;
        }

        isDragging = false;
        dragDirection = null;
        viewport.classList.remove('is-dragging');
      }

      function openStory(videoId) {
        var template = section.querySelector('[data-ugc-gallery-template="' + videoId + '"]');

        if (!modal || !modalPlayer || !template) {
          return;
        }

        modalPlayer.innerHTML = template.innerHTML;
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('sd-ugc-gallery-story-open');

        var video = modalPlayer.querySelector('video');

        if (video) {
          video.currentTime = 0;
          video.play().catch(function () {});
        }

        if (modalPanel) {
          modalPanel.focus();
        }
      }

      function closeStory() {
        if (!modal || !modalPlayer || modal.hidden) {
          return;
        }

        var video = modalPlayer.querySelector('video');

        if (video) {
          video.pause();
        }

        modalPlayer.innerHTML = '';
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('sd-ugc-gallery-story-open');
      }

      viewport.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) {
          return;
        }

        startDrag(event.clientX, event.clientY);
      });

      viewport.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });

      window.addEventListener('pointermove', function (event) {
        if (!isDragging) {
          return;
        }

        moveDrag(event.clientX, event.clientY);

        if (dragDirection === 'horizontal' && event.cancelable) {
          event.preventDefault();
        }
      });

      window.addEventListener('pointerup', stopDrag);
      window.addEventListener('pointercancel', stopDrag);

      section.addEventListener('click', function (event) {
        var button = event.target.closest('[data-ugc-gallery-target]');
        var openButton = event.target.closest('[data-ugc-gallery-open]');
        var closeButton = event.target.closest('[data-ugc-gallery-close]');

        if (hasDragged) {
          event.preventDefault();
          event.stopPropagation();
          hasDragged = false;
          return;
        }

        if (closeButton && section.contains(closeButton)) {
          event.preventDefault();
          closeStory();
          return;
        }

        if (openButton && section.contains(openButton)) {
          event.preventDefault();
          openStory(openButton.dataset.ugcGalleryVideoId);
          return;
        }

        if (!button || !section.contains(button)) {
          return;
        }

        var targetIndex = Number(button.dataset.ugcGalleryTarget);
        var targetItem = items[targetIndex];

        if (!targetItem) {
          return;
        }

        targetItem.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });

        setActiveDot(section, targetIndex);
      });

      viewport.addEventListener('scroll', function () {
        if (scrollFrame) {
          window.cancelAnimationFrame(scrollFrame);
        }

        scrollFrame = window.requestAnimationFrame(function () {
          setActiveDot(section, getClosestItemIndex(viewport, items));
          scrollFrame = null;
        });
      }, { passive: true });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeStory();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initUgcGallery();
    });
  } else {
    initUgcGallery();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initUgcGallery(event.target);
  });
})();
